export default "__VITE_PUBLIC_ASSET__a0259c5c__"